import Api from '@/repository/api';
import {IRecoverRepository} from '@/repository/recover/RecoverRepository.types';
import {RecoverCodeRequestType} from "@/form/recover/recoverCode/recoverCode.types";
import {RecoverMainRequestType} from "@/form/recover/recoverMain/recoverMain.types";
import {RecoverPasswordRequestType} from "@/form/recover/recoverPassword/recoverPassword.types";
import {ResponseDataType} from "@/form/form.types";
export class RecoverRepository implements IRecoverRepository {
    async sendCode(data: RecoverCodeRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/restore/confirm', data);
        return response.data;
    }
    async checkCode(data: RecoverMainRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/restore/phone', data);
        return response.data;
    }
    async recoverDo(data: RecoverPasswordRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/restore/password', data);
        return response.data;
    }
}
